// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"f30fec81","239":"b7533f08","677":"06b9dbcb","798":"9565bf6c","934":"7220a867"}[chunkId] + ".chunk.js";
};